import SVGIconWrapper from "./SVGIconWrapper"

const IconCheckmarkBold = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 921.8 706.5"
        iconClass={`icon--checkmark-bold ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <g><path d="M921.8,138c0,15.9-5.6,29.3-16.7,40.4L474.6,609l-80.9,80.9c-11.1,11.1-24.6,16.7-40.4,16.7c-15.9,0-29.3-5.5-40.4-16.7 L231.9,609L16.7,393.7C5.5,382.6,0,369.1,0,353.3c0-15.9,5.5-29.3,16.7-40.4l80.9-80.9c11.1-11.1,24.6-16.7,40.4-16.7 c15.9,0,29.3,5.6,40.4,16.7l174.8,175.4L743.4,16.6C754.5,5.6,768,0,783.8,0c15.9,0,29.3,5.6,40.4,16.7l80.9,80.9 C916.2,108.6,921.8,122.1,921.8,138z"/></g>
    </SVGIconWrapper>
)

export default IconCheckmarkBold